import { InputSelect } from '@bluevalet/common-ui';
import React from 'react';
import { WithTranslation, withTranslation } from 'react-i18next';
import { connect } from 'react-redux';

import { SiteCheckpointId } from '@/modules/common/model';

import { Trip as TripModel, TripStatus } from '../../booking/model';
import { State } from '../reducers';
import { isErrorField } from '../utils';

interface Checkpoint {
  id: SiteCheckpointId;
  name: string;
}

interface TripState {
  start: TripModel;
  end: TripModel;
}

interface StateProps {
  trip: TripState;
}

interface Props {
  prefix: 'start' | 'end';
  name: string;
  items: Array<Checkpoint>;
  value: SiteCheckpointId | undefined;
  onChange: (value: string) => void;
  label?: string;
  fastBooking?: boolean;
  forceValidation?: boolean;
}

const Dropdown = ({
  t,
  prefix,
  name,
  label,
  items,
  trip,
  onChange,
  value = '',
  fastBooking = false,
  forceValidation = false,
}: Props & WithTranslation & StateProps) => {
  const currentTrip = trip[prefix];

  // Si on n'est pas en "fast booking", alors on check si le voyage a bien été trouvé / forcé
  // et que le point de rendez-vous a été sélectionné
  // TODO: Essayer de valider le checkpoint choisi par le client
  // en fonction du "checkpoint" du trip sélectionné
  const isValidCheckpoint =
    !fastBooking && value !== ''
      ? currentTrip.status !== TripStatus.None && currentTrip.status !== TripStatus.Unknown
      : false;

  // Récupération de l'item déjà sélectionné
  const selectedItem = items.find(({ id }) => id === +(value || ''));

  // Si on n'est pas en "fast booking", alors on affiche les erreurs s'il y en a
  const hasErrors = isErrorField(forceValidation, value);
  const inputProps = {
    'data-cy': `${prefix}-checkpoint`,
    success: isValidCheckpoint,
    error: hasErrors,
    message: hasErrors ? t('error-required') : '',
  };

  return (
    <InputSelect
      id={`${prefix}-checkpoint`}
      name={name}
      label={label}
      value={value}
      title={selectedItem && selectedItem.name}
      onChange={onChange}
      placeholder={t('select')}
      {...inputProps}>
      {items.map(i => (
        <option key={i.id} value={i.id}>
          {i.name}
        </option>
      ))}
    </InputSelect>
  );
};

const mapStateToProps = (state: State): StateProps => ({ trip: state.trip });

export default connect(mapStateToProps)(withTranslation()(Dropdown));
